export default __webpack_public_path__ + "static/media/NodeMCU.af3dd565.png";